// Canonical marker embedded in the welcome message of an onboarding session.
// Keep in sync with `be/core/argus/constants.py` (ONBOARDING_WELCOME_SENTINEL).
export const ONBOARDING_WELCOME_SENTINEL = "<!-- argus:onboarding-welcome -->";
